<template>
    <div>
        <div class="text_loder">
           <p><img src="../assets/images/icons/google_drive.gif" />Connecting to Google Drive</p> 
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        callBackurl:'',
        gDriveOauthToken:'',
        googleDriveFiles:[],
        encodedString:'',
    }),
    components:{

    },
    methods:{
        handleClick(){
            if(tokenClient){
                tokenClient.callback = async (response) => {
                if (response.error !== undefined) {
                    throw (response);
                }
                accessToken = response.access_token;
                if(accessToken){
                    this.gDriveOauthToken = accessToken;
                }
                    await this.createPicker();
                };
                if (accessToken === null) {
                    // Prompt the user to select a Google Account and ask for consent to share their data
                    // when establishing a new session.
                    tokenClient.requestAccessToken({prompt: 'consent'});
                } else {
                    // Skip display of account chooser and consent dialog for an existing session.
                    tokenClient.requestAccessToken({prompt: ''});
                }
            }
        },
        async createPicker() {
            var $self = this;
            const view = new google.picker.View(google.picker.ViewId.DOCS);
            view.setMimeTypes();
            const picker = new google.picker.PickerBuilder()
            .enableFeature(google.picker.Feature.NAV_HIDDEN)
            .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
            .setDeveloperKey(API_KEY)
            .setAppId(APP_ID)
            .setOAuthToken($self.gDriveOauthToken)
            .addView(view)
            .addView(new google.picker.DocsUploadView())
            .setCallback($self.pickerCallback)
            .build();
            picker.setVisible(true);
        },
        async pickerCallback(data) {
            let self = this;
            this.googleDriveFiles = [];
            if (data.action === google.picker.Action.PICKED) {
                if(data && data['docs'] && data['docs'].length>0){
                    let docList = [];
                    let item = {
                        id:'',
                        name:''
                    }
                    _.forEach(data['docs'], (itm)=>{
                        if(_.has(itm, 'id') && _.has(itm, 'name') && itm['id'] && itm['name'] ){
                            item['id'] = itm['id'];
                            item['name'] = itm['name'];
                            let findObj = _.find(docList, {'id':itm['id']});
                            if(!findObj){
                                docList.push(item);
                            }
                            item = {
                                id:'',
                                name:''
                            }
                        };
                    })
                    if(docList && docList.length>0){
                        const string = JSON.stringify(docList) // convert Object to a String
                        this.encodedString = btoa(string) // Base64 encode the String
                        // console.log(JSON.stringify(docList));
                        // console.log(this.encodedString);
                    }
                    //self.googleDriveFiles = _.cloneDeep(data['docs']);
                    //self.redirectWindowOrigin();
                    self.redirectToParentOrigin();
                }
            }
            if(data.action === 'cancel'){
                self.googleDriveFiles = [];
                self.redirectWindowOrigin()
            }
        },
        redirectToParentOrigin(){
            window.location.href = this.callBackurl+"/google-drive-check?accessToken="+this.gDriveOauthToken+"&docs="+this.encodedString;
        },
        redirectWindowOrigin(){
            if(this.gDriveOauthToken && this.callBackurl){
                const dataToSend = { message: 'Hello from the child window!',
                token :this.gDriveOauthToken,
                googleDriveFiles: this.googleDriveFiles };
                window.opener.postMessage(dataToSend, this.callBackurl /* replace with your parent window origin */);
                window.close();
            }
        },
    },
    mounted(){
        let self = this;
        this.googleDriveFiles = [];
        if(this.$route.query && this.$route.query.location){
            this.callBackurl = this.$route.query.location;
        }
        if(this.$route.query && this.$route.query.token){
            this.gDriveOauthToken = this.$route.query.token
            setTimeout(()=>{
                self.createPicker();
            })
        }else if(this.callBackurl  && !this.$route.query.token && !this.gDriveOauthToken){
            this.handleClick();
        }else if(this.$route.query && this.$route.query.accessToken && this.$route.query.docs){
            let docList = this.$route.query.docs;
            this.googleDriveFiles = JSON.parse(atob(docList));
            this.gDriveOauthToken = this.$route.query.accessToken;
            this.callBackurl = window.location.origin;
            this.redirectWindowOrigin()
        }
    }
}
</script>